<template>
  <div id="filter-modal" class="mt-4">
    <div v-if="_tab === 0">
      <v-row>
        <v-card-text class="font-weight-bold ml-11 pb-1">
          Filter by range
        </v-card-text>
        <v-item-group v-model="filterParams.return.range">
          <v-row>
            <v-spacer />
            <v-col class="pa-0">
              <v-item
                v-slot:default="{ active, toggle }"
                class="ma-1"
                value="Today"
              >
                <v-btn
                  class="text-capitalize"
                  tile
                  elevation="0"
                  width="99"
                  id="filter-today"
                  :style="
                    active
                      ? `border: 2px solid ${$vuetify.theme.currentTheme.secondary};
                    background-color: white;`
                      : ''
                  "
                  @click="toggle"
                  >Today</v-btn
                >
              </v-item>
              <v-item
                v-slot:default="{ active, toggle }"
                class="mx-1 mb-1"
                value="This Year"
              >
                <v-btn
                  class="text-capitalize"
                  tile
                  elevation="0"
                  width="99"
                  id="filter-this-year"
                  :style="
                    active
                      ? `border: 2px solid ${$vuetify.theme.currentTheme.secondary};
                    background-color: white;`
                      : ''
                  "
                  @click="toggle"
                  >This Year</v-btn
                >
              </v-item>
            </v-col>
            <v-col class="pa-0">
              <v-item
                v-slot:default="{ active, toggle }"
                class="mt-1"
                value="Yesterday"
              >
                <v-btn
                  class="text-capitalize"
                  tile
                  elevation="0"
                  width="99"
                  id="filter-yesterday"
                  :style="
                    active
                      ? `border: 2px solid ${$vuetify.theme.currentTheme.secondary};
                    background-color: white;`
                      : ''
                  "
                  @click="toggle"
                  >Yesterday</v-btn
                >
              </v-item>
              <v-item
                v-slot:default="{ active, toggle }"
                class="my-1"
                value="Last Week"
              >
                <v-btn
                  class="text-capitalize"
                  tile
                  elevation="0"
                  width="99"
                  id="filter-last-week"
                  :style="
                    active
                      ? `border: 2px solid ${$vuetify.theme.currentTheme.secondary};
                    background-color: white;`
                      : ''
                  "
                  @click="toggle"
                  >Last Week</v-btn
                >
              </v-item>
            </v-col>
            <v-col class="pa-0">
              <v-item
                v-slot:default="{ active, toggle }"
                class="ma-1"
                value="This Month"
              >
                <v-btn
                  class="text-capitalize"
                  tile
                  elevation="0"
                  width="99"
                  id="filter-this-month"
                  :style="
                    active
                      ? `border: 2px solid ${$vuetify.theme.currentTheme.secondary};
                    background-color: white;`
                      : ''
                  "
                  @click="toggle"
                  >This Month</v-btn
                >
              </v-item>
              <v-item
                v-slot:default="{ active, toggle }"
                class="mx-1 mb-1"
                value="Last Month"
              >
                <v-btn
                  class="text-capitalize"
                  tile
                  elevation="0"
                  width="99"
                  id="filter-last-month"
                  :style="
                    active
                      ? `border: 2px solid ${$vuetify.theme.currentTheme.secondary};
                    background-color: white;`
                      : ''
                  "
                  @click="toggle"
                  >Last Month</v-btn
                >
              </v-item>
            </v-col>
            <v-spacer />
          </v-row>
        </v-item-group>
      </v-row>
      <v-row class="mx-9 mt-10">
        <v-col class="pl-0 py-0">
          <v-menu
            v-model="startMenu"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                filled
                dense
                id="filter-start-date"
                v-model="filterParams.return.start_date"
                label="Start Date"
                append-icon="mdi-calendar-blank"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="filterParams.return.start_date"
              no-title
              id="filter-start-picker"
              @input="startMenu = false"
            ></v-date-picker>
          </v-menu>
        </v-col>
        <v-col class="pr-0 py-0">
          <v-menu
            v-model="endMenu"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                filled
                dense
                id="filter-end-date"
                v-model="filterParams.return.end_date"
                label="End Date"
                append-icon="mdi-calendar-blank"
                v-on="on"
                :rules="[rules.afterStart]"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="filterParams.return.end_date"
              no-title
              id="filter-end-picker"
              :min="filterParams.return.start_date"
              @input="endMenu = false"
            ></v-date-picker>
          </v-menu>
        </v-col>
      </v-row>
      <v-row class="mx-9">
        <v-select
          filled
          dense
          :items="_filterOptions.return.tripType"
          label="Trip Type"
          color="secondary"
          id="filter-trip"
          v-model="filterParams.return.tripType"
        ></v-select>
      </v-row>
      <v-row class="mx-9">
        <v-select
          filled
          dense
          :items="_filterOptions.return.rentalStatusType"
          label="Rental Status Type"
          class="pt-0"
          color="secondary"
          id="filter-status"
          v-model="filterParams.return.searchRentalStatus"
        ></v-select>
      </v-row>
      <!-- <v-row class="mx-9">
        <v-select
          filled
          dense
          label="Search Destination"
          color="secondary"
          v-model="filterParams.return.searchDestination"
        ></v-select>
      </v-row> -->
      <v-row class="mx-9">
        <v-select
          filled
          dense
          :items="_filterOptions.return.groups"
          label="Search Groups"
          color="secondary"
          id="filter-group"
          v-model="filterParams.return.searchGroups"
        ></v-select>
      </v-row>
      <v-row class="mx-9">
        <v-select
          filled
          dense
          :items="_filterOptions.return.tablets"
          label="Search Tablets"
          color="secondary"
          id="filter-device"
          v-model="filterParams.return.searchTablets"
        ></v-select>
      </v-row>
    </div>
    <div v-else class="mt-6">
      <!-- <v-row class="mx-9">
        <v-select
          filled
          dense
          :items="_filterOptions.oneWay.confirmation"
          label="Confirmation"
          color="secondary"
          v-model="filterParams.oneWay.confirmation"
        ></v-select>
      </v-row> -->
      <!-- <v-row class="mx-9">
        <v-select
          filled
          dense
          :items="_filterOptions.oneWay.callStatus"
          label="Call Status"
          color="secondary"
          v-model="filterParams.oneWay.callStatus"
        ></v-select>
      </v-row> -->
      <!-- <v-row class="mx-9">
        <v-select
          filled
          dense
          :items="_filterOptions.oneWay.destination"
          label="Search Destination"
          color="secondary"
          v-model="filterParams.oneWay.searchDestination"
        ></v-select>
      </v-row> -->
      <!-- <v-row class="mx-9">
        <v-select
          filled
          dense
          :items="_filterOptions.oneWay.stores"
          label="Search Stores"
          color="secondary"
          v-model="filterParams.oneWay.searchStores"
        ></v-select>
      </v-row> -->
      <v-row class="mx-9">
        <v-select
          filled
          dense
          :items="_filterOptions.oneWay.tablets"
          label="Search Tablets"
          color="secondary"
          id="filter-device"
          v-model="filterParams.oneWay.searchTablets"
        ></v-select>
      </v-row>
      <!-- <v-row class="mx-9">
        <v-select
          filled
          dense
          :items="_filterOptions.oneWay.contacts"
          label="Search Contacts"
          color="secondary"
          v-model="filterParams.oneWay.searchContacts"
        ></v-select>
      </v-row> -->
      <v-row class="mx-9">
        <v-select
          filled
          dense
          :items="_filterOptions.oneWay.rentalStatusType"
          label="Search Rental Status"
          color="secondary"
          id="filter-status"
          v-model="filterParams.oneWay.searchRentalStatus"
        ></v-select>
      </v-row>
    </div>
  </div>
</template>
<script>
import moment from 'moment';
import { mapGetters } from 'vuex';
import FilterParams from '@/mixins/FilterParams';

export default {
  mixins: [FilterParams],
  data() {
    return {
      startMenu: false,
      endMenu: false,
      rules: {
        afterStart: () => moment(this.filterParams.start_date).isBefore(
          moment(this.filterParams.end_date),
        ) || 'End date must be later than start date',
      },
    };
  },
  computed: {
    ...mapGetters({
      _tab: 'reconciliation/getTab',
      _filterOptions: 'filters/getReconciliationFilterOptions',
    }),
  },
  watch: {
    filterParams: {
      handler() {
        if (this.filterParams.return.range === 'Today') {
          const time = moment().format('YYYY-MM-DD');
          this.filterParams.return.start_date = time;
          this.filterParams.return.end_date = moment()
            .add(1, 'day')
            .format('YYYY-MM-DD');
        } else if (this.filterParams.return.range === 'Yesterday') {
          const time = moment()
            .subtract(1, 'days')
            .format('YYYY-MM-DD');
          this.filterParams.return.start_date = time;
          this.filterParams.return.end_date = moment(time)
            .add(1, 'day')
            .format('YYYY-MM-DD');
        } else if (this.filterParams.return.range === 'This Month') {
          const startOfMonth = moment()
            .startOf('month')
            .format('YYYY-MM-DD');
          const endOfMonth = moment()
            .endOf('month')
            .format('YYYY-MM-DD');
          this.filterParams.return.start_date = startOfMonth;
          this.filterParams.return.end_date = endOfMonth;
        } else if (this.filterParams.return.range === 'This Year') {
          const startOfYear = moment()
            .startOf('year')
            .format('YYYY-MM-DD');
          const endOfYear = moment()
            .endOf('year')
            .format('YYYY-MM-DD');
          this.filterParams.return.start_date = startOfYear;
          this.filterParams.return.end_date = endOfYear;
        } else if (this.filterParams.return.range === 'Last Week') {
          const startOfWeek = moment()
            .subtract(1, 'weeks')
            .startOf('isoWeek')
            .format('YYYY-MM-DD');
          const endOfWeek = moment()
            .subtract(1, 'weeks')
            .endOf('isoWeek')
            .format('YYYY-MM-DD');
          this.filterParams.return.start_date = startOfWeek;
          this.filterParams.return.end_date = endOfWeek;
        } else if (this.filterParams.return.range === 'Last Month') {
          const startOfMonth = moment()
            .subtract(1, 'months')
            .startOf('month')
            .format('YYYY-MM-DD');
          const endOfMonth = moment()
            .subtract(1, 'months')
            .endOf('month')
            .format('YYYY-MM-DD');
          this.filterParams.return.start_date = startOfMonth;
          this.filterParams.return.end_date = endOfMonth;
        } else if (this.filterParams.return.range === 'This Week') {
          const startOfWeek = moment()
            .startOf('isoWeek')
            .format('YYYY-MM-DD');
          const endOfWeek = moment()
            .endOf('isoWeek')
            .format('YYYY-MM-DD');
          this.filterParams.return.start_date = startOfWeek;
          this.filterParams.return.end_date = endOfWeek;
        } else if (this.filterParams.return.range === 'Last Year') {
          const startOfYear = moment()
            .subtract(1, 'years')
            .startOf('year')
            .format('YYYY-MM-DD');
          const endOfYear = moment()
            .subtract(1, 'years')
            .endOf('year')
            .format('YYYY-MM-DD');
          this.filterParams.return.start_date = startOfYear;
          this.filterParams.return.end_date = endOfYear;
        }
      },
      deep: true,
    },
  },
};
</script>
